export default __webpack_public_path__ + "static/media/new-arrow.47ecf002.svg";